import { Validators } from '@angular/forms';
import { TypedFormControl, TypedFormGroup } from '@principle-theorem/ng-shared';
import {
  type IPodiumLocationMap,
  type IPractice,
} from '@principle-theorem/principle-core/interfaces';
import { type DocumentReference } from '@principle-theorem/shared';

export class PodiumPracticeLocationFormGroup extends TypedFormGroup<IPodiumLocationMap> {
  constructor() {
    super({
      practiceRef: new TypedFormControl<DocumentReference<IPractice>>(
        undefined,
        [Validators.required]
      ),
      locationUid: new TypedFormControl<string>(undefined, [
        Validators.required,
      ]),
    });
  }
}
